
import { Component, Prop,Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import { EventData } from '@/common-datatypes'
import UserInboxOnReferenceObjects from "@/components/UserInboxOnReferenceObjects.vue"
import ModalEventMessenger from "@/components/ModalUserEventMessenger.vue"
import EventDetails from "@/components/EventDetails.vue"
import ICalEventDetails from "@/components/ICalEventDetails.vue"

@Component({
  components: {
    UserInboxOnReferenceObjects,
    ModalEventMessenger,
    EventDetails,
    ICalEventDetails
  }
})

export default class ModalUserEventDetails extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string

  //@Prop({type: String, default: ''}) private title?: string
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  isLoading: boolean | string = false

  defaultModalMessengerProps = {
    replyMessageId: '',
    replyAllMessageId: '',
    theMessageId: '',
    theEventData: this.theEventData,
    isShow: false
  }

  modalMessengerProps = {} as this["defaultModalMessengerProps"]

  isActive = true

  get referenceObjectIds(){
    return (this.theEventData?.extendedProps.docId) ? [this.theEventData?.extendedProps.docId] : []
  }

  get eventId(){
    return this.theEventData?.id || ''
  }

  get title(){
    return this.theEventData?.title || ''
  }

  async created(){
    //
  }

  mounted(){
    //
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes)
  }

  createMessage(){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  editMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theMessageId: messageId,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  replyMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyMessageId: messageId,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  replyAllMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyAllMessageId: messageId,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  destroyed() {
    console.trace('destroyed');
  }
}
